const hasMap = document.querySelector('#map');
// const API_BASE_URL = "/api/map.php";
// const GOOGLE_MAPS_API_KEY = "AIzaSyBkIVAmcyfDXn_z0LC3VMh51zJ1QNVh-pI";
if (hasMap !== null) {
    /* =========================================================================
            API CONFIG
            Facility data comes from a live backend (paginated) that now returns
            lat/lng directly per record, so no client-side geocoding of the dataset
            is needed. "Results per page" in the UI maps directly to this API's
            `pageSize` query param.
         
            NOTE — CORS: the upstream API doesn't return the headers browsers need
            to call it directly from client-side JS. Requests instead go through
            proxy.php (included alongside this file), which fetches server-side and
            relays the response with proper CORS headers attached. Deploy proxy.php
            on the same host as this HTML file and update API_BASE_URL below to
            point at it, e.g. "https://yourdomain.com/proxy.php".
            ========================================================================= */
    const API_BASE_URL = "/api/map.php";

    // Auth is now handled server-side inside proxy.php (see UPSTREAM_API_KEY
    // there), so this stays unused unless you call the upstream API directly.
    const API_AUTH_TOKEN = null;

    /* =========================================================================
       CONFIG
       ========================================================================= */
    // TODO: replace with your own Google Maps API key (enable Maps JavaScript API
    // + Geocoding API in Google Cloud Console).
    const GOOGLE_MAPS_API_KEY = "AIzaSyBkIVAmcyfDXn_z0LC3VMh51zJ1QNVh-pI";

    const DEFAULT_CENTER = { lat: 39.5, lng: -98.35 }; // continental US
    const DEFAULT_ZOOM = 4;

    // Fallback center used for distance/radius whenever the user hasn't
    // searched and browser geolocation is unavailable or denied.
    const FALLBACK_LOCATION_QUERY = "Tulsa, OK";
    const FALLBACK_LOCATION_COORDS = { lat: 36.1539816, lng: -95.9927535 }; // used if geocoding itself fails

    // Grayscale "Snazzy Maps" style — strips color, keeps roads/labels legible.
    /* Custom pin icon, embedded inline so the file stays a single portable HTML
       document. Swap this data URI for your own if you want a different pin —
       or point it at a hosted URL instead (e.g. "https://yourcdn.com/pin.png"). */
    const CUSTOM_PIN_ICON = "data:image/webp;base64,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";

    const GRAYSCALE_MAP_STYLE = [
        {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": 65
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "lightness": "50"
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "30"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": "40"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "hue": "#ffff00"
                },
                {
                    "lightness": -25
                },
                {
                    "saturation": -97
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "lightness": -25
                },
                {
                    "saturation": -100
                }
            ]
        }
    ]

    /* =========================================================================
       STATE
       ========================================================================= */
    let map, geocoder, autocomplete;
    let markers = [];
    let activeInfoWindow = null;
    let allLocations = [];
    let defaultCenter = null;   // resolved once at load: geolocation, else Tulsa, OK fallback
    let currentCenter = null;   // active center used for distance — always mirrors defaultCenter
    // unless the user has an active search
    let filteredResults = [];
    let radiusCircle = null;    // google.maps.Circle showing the active search radius
    const geocodeCache = {};    // address -> { lat, lng }, resolved once per session (search box only)

    /* =========================================================================
       DATA LOADING — live API
       Maps the API's { id, title, address1, address2, phone_number, url, zip,
       lat, lng } shape into the internal shape the rest of the app uses. The
       API returns coordinates directly, so no client-side geocoding of the
       dataset is needed — records load and plot immediately.
    
       Showing an accurate "N closest locations" means we need distances across
       the WHOLE dataset, not just one API page — the nearest 50 to Tulsa could
       easily be scattered outside whatever a single page happens to contain.
       So on load we pull every page (fetchAllFacilities), then do all
       filtering/sorting/radius/keyword logic client-side against the full set.
       "Results per page" now controls how many of the (already-loaded,
       already-sorted) results are shown, not how many are fetched.
       ========================================================================= */
    async function fetchFacilitiesPage(page, pageSize) {
        const url = `${API_BASE_URL}?page=${page}&pageSize=${pageSize}`;
        const headers = {};
        if (API_AUTH_TOKEN) headers["Authorization"] = API_AUTH_TOKEN;

        const res = await fetch(url, { headers });
        if (!res.ok) {
            throw new Error(`Facility API returned ${res.status} ${res.statusText}`);
        }
        const json = await res.json();

        const records = (json.data || [])
            .map(rec => {
                const lat = parseFloat(rec.lat);
                const lng = parseFloat(rec.lng);
                return {
                    id: rec.id,
                    name: rec.title || "Untitled Location",
                    address1: rec.address1 || "",
                    address2: rec.address2 || "",
                    zip: rec.zip || "",
                    address: [rec.address1, rec.address2, rec.zip].filter(Boolean).join(", "),
                    contact: rec.phone_number || "",
                    website: rec.url || "",
                    lat,
                    lng,
                };
            })
            // Drop any record with missing/invalid coordinates rather than letting
            // it silently break map rendering or distance math.
            .filter(loc => Number.isFinite(loc.lat) && Number.isFinite(loc.lng));

        return { records, total: json.total || records.length, hasMore: !!json.hasMore };
    }

    // Safety cap so a runaway/huge backend dataset can't stall the browser
    // fetching thousands of pages. Raise if your real dataset legitimately
    // exceeds this.
    const MAX_FETCH_RECORDS = 3000;
    // The API only accepts pageSize values of 25/50/75/100 — 100 is the
    // largest chunk available, so that's what the bulk fetch uses regardless
    // of what's selected in the "Results per page" dropdown.
    const BULK_PAGE_SIZE_REQUESTED = 100;
    const BULK_FETCH_CONCURRENCY = 8;

    /* Fetches the full dataset, but calls onFirstPage as soon as page 1 lands
       so the caller can render something immediately instead of blocking on
       every page — this is what makes the initial load feel fast even though
       the full ~1,900-record set is still being pulled in the background. */
    async function fetchAllFacilities(onFirstPage) {
        const statusEl = document.getElementById("statusMsg");
        statusEl.textContent = "Loading locations...";
        showSidebarLoader("Loading locations...");

        const first = await fetchFacilitiesPage(1, BULK_PAGE_SIZE_REQUESTED);
        const all = [...first.records];

        // Use however many records actually came back as the effective page
        // size for pagination math, in case the API capped our requested size.
        const effectivePageSize = first.records.length || BULK_PAGE_SIZE_REQUESTED;
        const total = Math.min(first.total, MAX_FETCH_RECORDS);
        const totalPages = Math.ceil(total / effectivePageSize);

        hideSidebarLoader();
        if (onFirstPage) onFirstPage([...all], total, totalPages > 1);

        if (totalPages > 1) {
            const remainingPages = [];
            for (let p = 2; p <= totalPages; p++) remainingPages.push(p);

            let nextIndex = 0;
            let completed = 1; // page 1 already done
            async function worker() {
                while (nextIndex < remainingPages.length) {
                    const page = remainingPages[nextIndex++];
                    const result = await fetchFacilitiesPage(page, effectivePageSize);
                    all.push(...result.records);
                    completed++;
                    showBackgroundLoader(`Loading more locations… (${Math.min(completed * effectivePageSize, total)}/${total})`);
                }
            }

            const workerCount = Math.min(BULK_FETCH_CONCURRENCY, remainingPages.length);
            await Promise.all(Array.from({ length: workerCount }, () => worker()));
            hideBackgroundLoader();
        }

        statusEl.textContent = "";
        return all;
    }

    /* =========================================================================
       GEOCODE A SINGLE ADDRESS (promise wrapper around the Geocoder, cached)
       ========================================================================= */
    function geocodeAddress(address) {
        if (geocodeCache[address]) return Promise.resolve(geocodeCache[address]);

        return new Promise((resolve) => {
            geocoder.geocode({ address }, (results, status) => {
                if (status === "OK" && results[0]) {
                    const loc = results[0].geometry.location;
                    const coords = { lat: loc.lat(), lng: loc.lng() };
                    geocodeCache[address] = coords;
                    resolve(coords);
                } else {
                    console.warn(`Geocoding failed for "${address}": ${status}`);
                    resolve(null);
                }
            });
        });
    }

    /* =========================================================================
       DISTANCE (Haversine, in miles)
       ========================================================================= */
    function milesBetween(lat1, lng1, lat2, lng2) {
        const R = 3958.8; // earth radius in miles
        const toRad = d => d * Math.PI / 180;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLng / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    /* =========================================================================
       SIDEBAR LOADER — shown over the results list during the initial bulk
       fetch, an active search geocode, or a "locate me" request.
       ========================================================================= */
    function showSidebarLoader(message) {
        const loaderEl = document.getElementById("sidebarLoader");
        document.getElementById("sidebarLoaderText").textContent = message;
        loaderEl.classList.add("active");
    }
    function hideSidebarLoader() {
        document.getElementById("sidebarLoader").classList.remove("active");
    }

    /* Small non-blocking indicator next to the results count — used while more
       pages load in the background after the first page is already rendered. */
    function showBackgroundLoader(message) {
        document.getElementById("bgLoaderText").textContent = message;
        document.getElementById("bgLoader").classList.add("active");
    }
    function hideBackgroundLoader() {
        document.getElementById("bgLoader").classList.remove("active");
    }

    /* =========================================================================
       TEXT MATCH — checks the query against title, address1, address2, zip
       ========================================================================= */
    function textMatches(query, loc) {
        const q = query.toLowerCase();
        return [loc.name, loc.address1, loc.address2, loc.zip]
            .some(field => field && field.toLowerCase().includes(q));
    }

    /* =========================================================================
       AUTO-LOCATE — tries the browser's geolocation once on initial load so
       the radius filter has a center point to work from immediately, instead
       of requiring the user to search first. Silently falls back to showing
       everything unfiltered if permission is denied or unavailable.
       ========================================================================= */
    let geoAttempted = false;

    function getBrowserLocation() {
        return new Promise(resolve => {
            if (!navigator.geolocation) return resolve(null);
            navigator.geolocation.getCurrentPosition(
                pos => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
                () => resolve(null),           // denied / unavailable / timed out
                { timeout: 6000, maximumAge: 300000 }
            );
        });
    }

    /* =========================================================================
       MAP INIT (called by Google Maps script callback)
       ========================================================================= */
    async function initMap() {
        map = new google.maps.Map(document.getElementById("map"), {
            center: DEFAULT_CENTER,
            zoom: DEFAULT_ZOOM,
            styles: GRAYSCALE_MAP_STYLE,
            disableDefaultUI: true, // removes Google's built-in zoom/map-type/street-view/fullscreen controls
        });
        geocoder = new google.maps.Geocoder();

        const searchInputEl = document.getElementById("searchInput");

        // Autosuggestion — Google Places Autocomplete dropdown as the user types.
        // Restricted to addresses/zips/cities (no businesses) to match "search
        // based on postal code and addresses."
        autocomplete = new google.maps.places.Autocomplete(searchInputEl, {
            types: ["geocode"],
            fields: ["geometry", "formatted_address", "name"],
        });
        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.geometry) {
                // User pressed Enter without picking a suggestion — fall back to a
                // manual geocode of whatever text is in the box.
                runSearch();
                return;
            }
            const statusEl = document.getElementById("statusMsg");
            currentCenter = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            searchInputEl.value = place.formatted_address || place.name || searchInputEl.value;
            statusEl.textContent = `Centered on ${place.formatted_address || place.name}`;
            map.setCenter(currentCenter);
            map.setZoom(9);
            applyFiltersAndRender();
        });

        document.getElementById("searchBtn").addEventListener("click", runSearch);
        searchInputEl.addEventListener("keydown", e => {
            if (e.key === "Enter") runSearch();
        });
        document.getElementById("radiusSelect").addEventListener("change", () => {
            applyFiltersAndRender();
        });
        document.getElementById("perPageSelect").addEventListener("change", () => {
            applyFiltersAndRender(); // full dataset is already loaded — just re-slice/re-render
        });

        addMapControls();

        await loadAndRender();
    }

    /* =========================================================================
       MAP CONTROLS — reset + locate-me buttons, docked bottom-right on the map
       via the Maps API's own control system (google.maps.ControlPosition), so
       they auto-stack above the built-in zoom control instead of overlapping it.
       ========================================================================= */
    function createMapButton(iconSvg, title, onClick) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.title = title;
        btn.setAttribute("aria-label", title);
        btn.className = "map-control-btn";
        btn.innerHTML = iconSvg;
        btn.addEventListener("click", onClick);
        return btn;
    }

    const RESET_ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <polyline points="1 4 1 10 7 10"></polyline>
  <polyline points="23 20 23 14 17 14"></polyline>
  <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
</svg>`;

    const LOCATE_ICON = `<svg viewBox="0 0 24 24" fill="currentColor">
  <path d="M3 11l19-9-9 19-2-8-8-2z"></path>
</svg>`;

    function addMapControls() {
        const wrapper = document.createElement("div");
        wrapper.className = "map-controls-wrapper";

        const resetBtn = createMapButton(RESET_ICON, "Reset map", handleResetMap);
        const locateBtn = createMapButton(LOCATE_ICON, "Use my location", handleLocateMe);

        wrapper.appendChild(resetBtn);
        wrapper.appendChild(locateBtn);

        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(wrapper);
    }

    /* Reset — clears the search, restores default filters (50 per page, 25 mi
       radius), and re-centers on the resolved default center (geolocation or
       Tulsa fallback). Data's already fully loaded, so this just re-renders —
       no re-fetch needed. */
    function handleResetMap() {
        const statusEl = document.getElementById("statusMsg");

        document.getElementById("searchInput").value = "";
        document.getElementById("radiusSelect").value = "25";
        document.getElementById("perPageSelect").value = "50";
        currentCenter = defaultCenter;
        statusEl.textContent = "";

        map.setCenter(currentCenter || DEFAULT_CENTER);
        map.setZoom(currentCenter ? 9 : DEFAULT_ZOOM);
        applyFiltersAndRender();
    }

    /* Locate me — re-requests browser geolocation on demand (works even if an
       earlier automatic attempt was denied, since this is a fresh user gesture). */
    async function handleLocateMe() {
        const statusEl = document.getElementById("statusMsg");
        statusEl.textContent = "Locating...";
        showSidebarLoader("Locating...");

        const loc = await getBrowserLocation();
        hideSidebarLoader();
        if (loc) {
            defaultCenter = loc;
            currentCenter = loc;
            map.setCenter(loc);
            map.setZoom(9);
            statusEl.textContent = "Showing locations near you";
            applyFiltersAndRender();
        } else {
            statusEl.textContent = "Couldn't access your location — check browser permissions.";
            alert('The application does not have permission to use the Geolocation API.')
        }
    }

    /* =========================================================================
       LOAD (API fetch) THEN RENDER
       Called on initial page load and via the Reset button. Coordinates come
       straight from the API, so this is just a fetch — no per-record geocoding
       pass. Pulls the FULL dataset (see fetchAllFacilities) and resolves the
       default center in parallel, since accurate "closest N" results need the
       whole dataset's distances, not just one page.
       ========================================================================= */
    async function loadAndRender() {
        const statusEl = document.getElementById("statusMsg");
        let firstRenderDone = false;

        // Resolve a default center in parallel with the data fetch — try the
        // browser's location first, then fall back to Tulsa, OK if denied or
        // unavailable. Only runs once per page load. (getBrowserLocation has its
        // own 6s timeout, so this can't stall the first render indefinitely.)
        const centerPromise = (async () => {
            if (defaultCenter || geoAttempted) return;
            geoAttempted = true;

            const browserLoc = await getBrowserLocation();
            if (browserLoc) {
                defaultCenter = browserLoc;
            } else {
                const tulsaCoords = await geocodeAddress(FALLBACK_LOCATION_QUERY);
                defaultCenter = tulsaCoords || FALLBACK_LOCATION_COORDS;
            }
            currentCenter = defaultCenter;
        })();

        let fetchError = null;
        const fullData = await fetchAllFacilities(async (firstPageRecords) => {
            // Fires as soon as page 1 lands — render immediately rather than
            // waiting on the other ~15-20 requests, which is what made the
            // initial load feel slow before.
            await centerPromise;
            allLocations = firstPageRecords;
            if (currentCenter) {
                map.setCenter(currentCenter);
                map.setZoom(9);
            }
            statusEl.textContent = "";
            applyFiltersAndRender();
            firstRenderDone = true;
        }).catch(err => {
            fetchError = err;
            return null;
        });

        if (fullData === null) {
            console.error(fetchError);
            if (!firstRenderDone) {
                statusEl.textContent = "Couldn't load locations from the API. Check network/CORS settings.";
                hideSidebarLoader();
            }
            return;
        }

        // Full dataset has now finished loading in the background — refine the
        // view with it (matters for "closest N", since a nearer match could be
        // on a later page than the first).
        allLocations = fullData;
        applyFiltersAndRender();
    }

    /* =========================================================================
       SEARCH: checks address1 / address2 / zip / title, and (when the query
       geocodes) also captures coordinates to drive the radius filter.
       Clearing the box or a failed geocode falls back to defaultCenter (never
       null) so the sidebar always has a distance to show.
       ========================================================================= */
    function runSearch() {
        const statusEl = document.getElementById("statusMsg");
        const query = document.getElementById("searchInput").value.trim();

        if (!query) {
            currentCenter = defaultCenter;
            statusEl.textContent = "";
            applyFiltersAndRender();
            return;
        }

        statusEl.textContent = "Searching…";
        showSidebarLoader("Searching…");

        geocoder.geocode({ address: query }, (results, status) => {
            if (status === "OK" && results[0]) {
                const loc = results[0].geometry.location;
                currentCenter = { lat: loc.lat(), lng: loc.lng() }; // <-- captured coordinates
                statusEl.textContent = `Centered on ${results[0].formatted_address}`;
                map.setCenter(currentCenter);
                map.setZoom(9);
            } else {
                // Query didn't geocode (e.g. a facility name) — fall back to pure
                // keyword matching, but keep showing distances from defaultCenter
                // rather than losing them.
                currentCenter = defaultCenter;
                statusEl.textContent = `No exact location match for "${query}" — showing keyword matches.`;
            }
            hideSidebarLoader();
            applyFiltersAndRender();
        });
    }

    /* =========================================================================
       FILTER + RENDER
       Combines: locations within the selected radius of currentCenter UNION
       locations whose title/address1/address2/zip match the search text.
       currentCenter is (almost) always set — geolocation or the Tulsa, OK
       fallback — so distances show in the sidebar even before any search.
       ========================================================================= */
    /* =========================================================================
       FILTER + RENDER
       Two modes:
       - No search query (the initial/default/reset state): show the N closest
         locations to currentCenter (geolocation or the Tulsa fallback), where N
         is "Results per page" — this is the literal "50 closest on default
         load" behavior. Radius isn't applied here; it's a pure nearest-N view.
       - Active search query: locations within the selected radius of
         currentCenter UNION locations whose title/address1/address2/zip match
         the search text, sorted nearest-first, with the total match count shown
         and only the top "Results per page" actually rendered.
       Map pins and bounds always mirror exactly what's in the sidebar list, so
       what's plotted and what's listed never drift apart.
       ========================================================================= */
    function applyFiltersAndRender() {
        const query = document.getElementById("searchInput").value.trim();
        const radius = parseFloat(document.getElementById("radiusSelect").value);
        const perPage = parseInt(document.getElementById("perPageSelect").value, 10);

        // Attach distance from currentCenter (if any) to every location.
        const withDistance = allLocations.map(loc => ({
            ...loc,
            miles: currentCenter
                ? milesBetween(currentCenter.lat, currentCenter.lng, loc.lat, loc.lng)
                : null,
        }));

        let results;
        let displayed;

        if (!currentCenter) {
            // Extremely early call, before defaultCenter resolves — show
            // everything, alphabetical, as a graceful placeholder.
            results = [...withDistance].sort((a, b) => a.name.localeCompare(b.name));
            displayed = results.slice(0, perPage);
        } else if (!query) {
            // Default / reset state — the N closest locations overall, ignoring
            // the radius filter (radius only applies once there's an active search).
            results = [...withDistance].sort((a, b) => a.miles - b.miles).slice(0, perPage);
            displayed = results;
        } else {
            const inRadius = withDistance.filter(loc => loc.miles <= radius);
            const keywordMatch = withDistance.filter(loc => textMatches(query, loc));

            const byId = new Map();
            [...inRadius, ...keywordMatch].forEach(loc => byId.set(loc.id, loc));
            results = Array.from(byId.values()).sort((a, b) => a.miles - b.miles);
            displayed = results.slice(0, perPage);
        }

        filteredResults = results;   // total matches — drives the "N locations found" count
        renderResults(displayed);
        plotMarkers(displayed);
        drawRadiusCircle(query && currentCenter ? currentCenter : null, radius);
        if (displayed.length) fitBoundsToResults(displayed);
    }

    /* =========================================================================
       RADIUS CIRCLE — visualizes the active search radius on the map.
       Cleared when there's no currentCenter (i.e. no active geocoded search).
       ========================================================================= */
    function drawRadiusCircle(center, radiusMiles) {
        if (radiusCircle) {
            radiusCircle.setMap(null);
            radiusCircle = null;
        }
        if (!center) return;

        radiusCircle = new google.maps.Circle({
            map,
            center,
            radius: radiusMiles * 1609.34, // miles -> meters
            strokeColor: "#0E6E6E",
            strokeOpacity: 0.6,
            strokeWeight: 1.5,
            fillColor: "#0E6E6E",
            fillOpacity: 0.08,
            clickable: false,
        });
    }

    /* =========================================================================
       SIDEBAR RESULTS
       ========================================================================= */
    function renderResults(displayed) {
        const listEl = document.getElementById("resultsList");
        const countEl = document.getElementById("resultCount");

        const page = displayed;
        countEl.textContent = filteredResults.length;
        listEl.innerHTML = "";

        if (page.length === 0) {
            listEl.innerHTML = `<div id="noResults">No locations match your filters. Try a larger radius.</div>`;
            return;
        }

        page.forEach((loc, i) => {
            const card = document.createElement("div");
            card.className = "result-card";
            card.dataset.id = loc.id;
            const phone = loc.contact ? loc.contact : '';
            const cleaned = phone.replace(/\D/g, "");
            const milesHtml = loc.miles !== null
                ? `<span class="result-miles">${loc.miles.toFixed(1)} mi</span><br/>`
                : "";

            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lng}`;

            card.innerHTML = `
      <div class="result-title-row">
        <span class="result-index">${i + 1}</span>
        <span class="result-name">${loc.name}</span>
      </div>
      <div class="result-addr">
       <p>${loc.address1}</p>
            ${loc.address2 ? `<p>${loc.address2}</p>` : ''}
            ${loc.contact ? `<p><a href="tel:${cleaned}"> ${loc.contact}</a></p>` : ''}
      </div>
      ${milesHtml ? `<div style="margin-left:0;">${milesHtml}</div>` : ""}
      <div class="result-links">
        <a href="${directionsUrl}" target="_blank" rel="noopener noreferrer" onclick="window.open(this.href, '_blank'); return false;">Directions</a>
        ${loc.website ? `<a href="${loc.website}" target="_blank" rel="noopener noreferrer" onclick="window.open(this.href, '_blank'); return false;">Website</a>` : ""}
      </div>
    `;

            card.addEventListener("click", () => focusLocation(loc));
            listEl.appendChild(card);
        });
    }

    function focusLocation(loc) {
        document.querySelectorAll(".result-card").forEach(el => el.classList.remove("active"));
        const card = document.querySelector(`.result-card[data-id="${loc.id}"]`);
        if (card) card.classList.add("active");

        map.panTo({ lat: loc.lat, lng: loc.lng });
        map.setZoom(12);

        const marker = markers.find(m => m.locId === loc.id);
        if (marker) google.maps.event.trigger(marker, "click");
    }

    /* =========================================================================
       MAP PINS + INFO WINDOWS
       ========================================================================= */
    function plotMarkers(locations) {
        markers.forEach(m => m.setMap(null));
        markers = [];

        locations.forEach(loc => {
            const marker = new google.maps.Marker({
                position: { lat: loc.lat, lng: loc.lng },
                map: map,
                title: loc.name,
                icon: {
                    url: CUSTOM_PIN_ICON,
                    scaledSize: new google.maps.Size(40, 40),
                    anchor: new google.maps.Point(20, 38), // point of the pin touches the map
                },
            });
            marker.locId = loc.id;
            const phone = loc.contact ? loc.contact : '';
            const cleaned = phone.replace(/\D/g, "");

            const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lng}`;
            const infoContent = `
      <div class="iw flex gap-2 items-start">
      <img src="${CUSTOM_PIN_ICON}" alt="Pemgarda Pin" width="24" height="24" />
        <div>
            <h3 class="text-[#000!important]">${loc.name}</h3>
         <p>${loc.address1}</p>
        ${loc.address2 ? `<p>${loc.address2}</p>` : ''}
        ${loc.contact ? `<p class="font-medium"><a class="font-medium" href="tel:${cleaned}"> ${loc.contact}</a></p>` : ""}
        <div class="iw-links">
          <a href="${directionsUrl}" target="_blank" rel="noopener noreferrer" onclick="window.open(this.href, '_blank'); return false;">Get directions</a>
          ${loc.website ? `<a href="${loc.website}" target="_blank" rel="noopener noreferrer" onclick="window.open(this.href, '_blank'); return false;">Visit website</a>` : ""}
        </div>
        </div>
      </div>
    `;
            const infoWindow = new google.maps.InfoWindow({ content: infoContent });

            marker.addListener("click", () => {
                if (activeInfoWindow) activeInfoWindow.close();
                infoWindow.open(map, marker);
                activeInfoWindow = infoWindow;

                document.querySelectorAll(".result-card").forEach(el => el.classList.remove("active"));
                const card = document.querySelector(`.result-card[data-id="${loc.id}"]`);
                if (card) card.classList.add("active");
            });

            markers.push(marker);
        });
    }

    function fitBoundsToResults(locations) {
        if (locations.length === 0 && !currentCenter) return;

        const bounds = new google.maps.LatLngBounds();

        if (currentCenter && radiusCircle) {
            // Fit to the full radius circle so the search area is visible, not
            // just whichever pins happened to match.
            bounds.union(radiusCircle.getBounds());
        } else if (currentCenter) {
            bounds.extend(currentCenter);
        }

        locations.forEach(loc => bounds.extend({ lat: loc.lat, lng: loc.lng }));
        map.fitBounds(bounds);
    }

    window.initMap = initMap;

    (function loadGoogleMaps() {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY)}&callback=initMap&libraries=places`;
        script.async = true;
        script.onerror = () => {
            document.getElementById("statusMsg").textContent =
                "Google Maps failed to load — check GOOGLE_MAPS_API_KEY.";
        };
        document.head.appendChild(script);
    })();
}